"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useHasSortingColumns_1 = __importDefault(require("../../context/sorting/useHasSortingColumns"));
var useShowToolbar = function (props) {
    var title = props.title, columns = props.columns, isMobileHeader = props.isMobileHeader, filter = props.filter, actionsElement = props.actionsElement, isColumnSettings = props.isColumnSettings, toolbarElement = props.toolbarElement;
    var hasSortingColumns = (0, useHasSortingColumns_1.default)(columns);
    var showToolbar = (0, react_1.useMemo)(function () { return !!(title
        || (isMobileHeader && hasSortingColumns)
        || (isMobileHeader && filter.mobileElement)
        || (!isMobileHeader && filter.desktopElement)
        || actionsElement
        || isColumnSettings
        || toolbarElement); }, [
        title, isMobileHeader, hasSortingColumns, filter.mobileElement, filter.desktopElement,
        actionsElement, isColumnSettings, toolbarElement
    ]);
    return showToolbar;
};
exports.default = useShowToolbar;
